import React, { useState, useEffect } from "react";
import { FaStar } from "react-icons/fa";
import { jwtDecode } from "jwt-decode";
import {
  fetchUserReviews,
  updateReview,
  deleteReview
} from "../services/api";
import "../styles/Profile.css";

// Utility to get current user from JWT
function getCurrentUser() {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

const Profile = () => {
  const user = getCurrentUser();
  const [reviews, setReviews] = useState([]);
  const [editingReviewId, setEditingReviewId] = useState(null);
  const [editText, setEditText] = useState("");
  const [editRating, setEditRating] = useState(5);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (user && token) {
      fetchUserReviews(user.id, token)
        .then(data => setReviews(data || []))
        .catch(() => setReviews([]));


    }
  }, [user, token]);

  const startEditReview = (review) => {
    setEditingReviewId(review.id);
    setEditText(review.text);
    setEditRating(review.rating);
  };

  const saveEditReview = async () => {
    try {
      await updateReview(editingReviewId, editText, editRating, token);
      setReviews(reviews.map(r =>
        r.id === editingReviewId
          ? { ...r, text: editText, rating: editRating }
          : r
      ));
      setEditingReviewId(null);
    } catch (e) {}
  };

  const handleDeleteReview = async (reviewId) => {
    try {
      await deleteReview(reviewId, token);
      setReviews(reviews => reviews.filter(r => r.id !== reviewId));
    } catch (e) {}
  };

  if (!user) return <div className="profile-container">Please log in to view your profile.</div>;

  const avatarLetter = user.username ? user.username.charAt(0).toUpperCase() : "?";

  return (
    <div className="profile-container">
      <div className="profile-header-card">
        <div className="profile-avatar">{avatarLetter}</div>
        <h1>{user.username}</h1>
        <p className="profile-email">{user.email}</p>
      </div>
      <hr />

      <div className="profile-section">
        <h2><FaStar /> Reviewed Games</h2>
        {!reviews.length ? (
          <div className="empty-text">No reviews yet.</div>
        ) : (
          reviews.map(r => (
            <div className="profile-card" key={r.id}>
              <div><b>{r.gameName}</b></div>
              {editingReviewId === r.id ? (
                <>
                  <textarea
                    value={editText}
                    onChange={e => setEditText(e.target.value)}
                    maxLength={300}
                    rows={2}
                  />
                  <input
                    type="number"
                    min={1}
                    max={5}
                    value={editRating}
                    onChange={e => setEditRating(Number(e.target.value))}
                  />
                  <button onClick={saveEditReview}>Save</button>
                  <button onClick={() => setEditingReviewId(null)}>Cancel</button>
                </>
              ) : (
                <>
                  <div>Review: {r.text}</div>
                  <div><FaStar color="#FFD700" /> {r.rating}/5</div>
                  <button onClick={() => startEditReview(r)}>Edit</button>
                  <button onClick={() => handleDeleteReview(r.id)} style={{ marginLeft: 8 }}>Delete</button>
                </>
              )}
            </div>
          ))
        )}
      </div>


    </div>
  );
};

export default Profile;
